import { render, staticRenderFns } from "./OrderNoteEdit.vue?vue&type=template&id=87814698&scoped=true"
import script from "./OrderNoteEdit.vue?vue&type=script&lang=js"
export * from "./OrderNoteEdit.vue?vue&type=script&lang=js"
import style0 from "./OrderNoteEdit.vue?vue&type=style&index=0&id=87814698&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87814698",
  null
  
)

export default component.exports